import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

import { MyDraggable as Draggable } from '../../components/Core';
import HoverBar from '../../components/HoverBar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col } from 'reactstrap';

import { makeStyles } from '@material-ui/core/styles';
import { generateStyle, l, setOverLay } from '../../functions';
import { dummyProduct } from '../../consts/products';
import Icon from '../../components/Icons';

import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';

function mapStateToProps(state) {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
  };
}

const useStyles = makeStyles((theme) => ({
  layout1: (props) => ({
    '&.product-review .reviewlist .review-sec.review-data-section:before': {
      borderRight: '5px solid ' + setValue(props.custom_color),
      borderBottom: '5px solid ' + setValue(props.custom_color),
    },
    '&.product-review .reviewlist .review-sec.review-data-section:after': {
      borderTop: '5px solid ' + setValue(props.custom_color),
      borderLeft: '5px solid ' + setValue(props.custom_color),
    },
  }),
  layout2: (props) => ({
    '&.product-review .reviewlist .review-sec .review-info span,&.product-review .reviewlist .review-sec .authour-name span.title':
      {
        color: setValue(props.custom_color),
        borderColor: setValue(props.custom_color),
      },
  }),
  layout3: (props) => ({
    '&.product-review .reviewlist .review-sec .review-info span,&.product-review .reviewlist .review-sec .authour-name span.title,&.product-review .reviewlist .review-sec .authour-post-date,&.product-review .reviewlist .review-sec .review-star span':
      {
        color: setValue(props.custom_color),
        borderColor: setValue(props.custom_color),
      },
    '&.product-review .reviewlist .review-sec:before': {
      backgroundColor: setValue(props.custom_color),
    },
    '&.product-review .reviewlist .review-sec:hover .review-info span,.layout3.product-review .reviewlist .review-sec:hover .review-info p,&.product-review .reviewlist .review-sec:hover .authour-name span.title,&.product-review .reviewlist .review-sec:hover .authour-post-date,&.product-review .reviewlist .review-sec:hover .review-star span':
      {
        color: setValueContent(props.custom_color),
      },
  }),
  layout4: (props) => ({
    '&.product-review .reviewlist .review-sec .review-info span': {
      color: setValue(props.custom_color),
      borderColor: setValue(props.custom_color),
    },
    '&.product-review .reviewlist .review-sec .authour-name span.title': {
      color: setValueContent(props.custom_color),
    },
  }),
  layout5: (props) => ({
    '&.product-review .reviewlist .review-sec span.authour-post-date span': {
      backgroundColor: setValue(props.custom_color),
    },
    '&.product-review .reviewlist .review-sec .review-info span.title': {
      color: setValue(props.custom_color),
      borderColor: setValue(props.custom_color),
    },
  }),
}));

function setValue(value) {
  return value + importantValue(value);
}

function setValueContent(color) {
  return (color !== null && isDark(color) ? '#FFF' : '#000') + importantValue(color);
}

function importantValue(value) {
  return value !== null ? ' !important' : '';
}

function isDark(color) {
  // Variables for red, green, blue values
  var r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color) {
    if (color.match(/^rgb/)) {
      // If HEX --> store the red, green, blue values in separate variables
      color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      // If RGB --> Convert it to HEX: http://gist.github.com/983661
      color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

      r = color >> 16;
      g = (color >> 8) & 255;
      b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) return false;
    else return true;
  } else return true;
}

function InitReviews({ preview, props }) {
  let { payload } = props;

  if (payload === null) payload = props.options.payload;

  const {
    allowReview,
    allowVote,
    reviewTextColor,
    reviewBgColor,
    reviewStarsColor,
    currentDesign,
    custom_color,
    reviewsCount,
    btnBgColor,
    btnTxtColor,
  } = payload.datas || {
    allowReview: false,
    allowVote: false,
    reviewTextColor: null,
    reviewBgColor: null,
    currentDesign: 1,
    reviewsCount: 5,
    // btnBgColor: "green",
    // btnTxtColor: "white",
  };
  {
    console.log('payload.datas>>>>>>>>', payload.datas);
  }
  const cssSettings = generateStyle(payload, 'container');
  const cssSettingsText = generateStyle(payload, 'text', 'body');
  const cssSettingsHeading = generateStyle(payload, 'text', 'H4');
  const cssSettingsND = {
    ...cssSettingsText,
    fontSize: cssSettingsText.fontSize * 0.75,
  };

  const buttonCss = {
    color: btnTxtColor || props.settings['active_button_text_color'].color,
    backgroundColor: btnBgColor || props.settings['active_button_color'].bgColor,
    borderColor: btnBgColor || props.settings['active_button_color'].bgColor,
  };

  const classes = useStyles({ custom_color: custom_color || null });
  const appearanceSettings = props.settings;
  let cssButton = {
    backgroundColor: appearanceSettings['active_button_color'].bgColor || '',
    color: appearanceSettings['active_button_text_color'].color || '',
  };

  return (
    <Container fluid={payload.fullContainer} style={cssSettings}>
      {setOverLay(payload)}
      <Row>
        <Col xs={12} className='fullcol'>
          <div className={`product-review layout${currentDesign} ${classes['layout' + currentDesign]}`}>
            {(dummyProduct.reviews && dummyProduct.reviews.length > 0 && (
              <div className='reviewlist'>
                {dummyProduct.reviews.slice(0, reviewsCount).map((review, index) => (
                  <div key={index}>
                    {(!currentDesign || (currentDesign && currentDesign !== 5)) && (
                      <div
                        className='review-sec review-data-section'
                        style={{
                          color: reviewTextColor,
                          backgroundColor: reviewBgColor,
                        }}
                      >
                        {currentDesign && currentDesign !== 1 && (
                          <div className='review-info'>
                            <h4 style={cssSettingsHeading}>{review.review_title}</h4>
                            {(currentDesign && currentDesign === 4 && (
                              <div className='reviewtxt' style={cssSettingsText}>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: review.description,
                                  }}
                                ></p>
                              </div>
                            )) || (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: review.description,
                                }}
                              ></p>
                            )}
                          </div>
                        )}

                        <div className='review-author'>
                          <div className='authour-name' style={cssSettingsND}>
                            <span className='title' style={cssSettingsND}>
                              {review.author}
                            </span>
                            {_formatDate(review.date_add)}
                          </div>
                          <div className='review-star'>
                            <span
                              style={{
                                color: review.ratings >= 1 && reviewStarsColor,
                              }}
                              className={`fa fa-star ${review.ratings >= 1 && 'checked'}`}
                            ></span>
                            <span
                              style={{
                                color: review.ratings >= 2 && reviewStarsColor,
                              }}
                              className={`fa fa-star ${review.ratings >= 2 && 'checked'}`}
                            ></span>
                            <span
                              style={{
                                color: review.ratings >= 3 && reviewStarsColor,
                              }}
                              className={`fa fa-star ${review.ratings >= 3 && 'checked'}`}
                            ></span>
                            <span
                              style={{
                                color: review.ratings >= 4 && reviewStarsColor,
                              }}
                              className={`fa fa-star ${review.ratings >= 4 && 'checked'}`}
                            ></span>
                            <span
                              style={{
                                color: review.ratings == 5 && reviewStarsColor,
                              }}
                              className={`fa fa-star ${review.ratings == 5 && 'checked'}`}
                            ></span>
                          </div>
                        </div>

                        {(!currentDesign || (currentDesign && currentDesign === 1)) && (
                          <div className='review-info'>
                            <h4 style={cssSettingsHeading}>{review.review_title}</h4>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: review.description,
                              }}
                              style={cssSettingsText}
                            ></p>
                          </div>
                        )}

                        {allowVote && (
                          <div className='review-helpful'>
                            <div className='review-helpful-txt'>
                              <span className='txt'>Was this Review Helpful ? </span>
                              <span className='review-yes'>
                                <FontAwesomeIcon icon={['fas', 'thumbs-up']} style={{ color: reviewStarsColor }} /> Yes{' '}
                              </span>
                              <span className='review-no'>
                                <FontAwesomeIcon icon={['fas', 'thumbs-down']} style={{ color: reviewStarsColor }} /> No
                              </span>
                            </div>
                            <div className='review-helpful-count'>
                              <span>{review.helpful_votes}</span> out of{' '}
                              <span>{review.helpful_votes + review.not_helpful_votes}</span> reviews are useful.
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {currentDesign && currentDesign === 5 && (
                      <div
                        className='review-sec review-data-section'
                        style={{
                          color: reviewTextColor,
                          backgroundColor: reviewBgColor,
                        }}
                      >
                        {_getDayMonth(review.date_add)}
                        <div className='review-info'>
                          <h4 style={cssSettingsHeading}>{review.review_title}</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: review.description,
                            }}
                            style={cssSettingsText}
                          ></p>
                          <div className='review-author'>
                            <div className='review-star'>
                              <span
                                style={{
                                  color: review.ratings >= 1 && reviewStarsColor,
                                }}
                                className={`fa fa-star ${review.ratings >= 1 && 'checked'}`}
                              ></span>
                              <span
                                style={{
                                  color: review.ratings >= 2 && reviewStarsColor,
                                }}
                                className={`fa fa-star ${review.ratings >= 2 && 'checked'}`}
                              ></span>
                              <span
                                style={{
                                  color: review.ratings >= 3 && reviewStarsColor,
                                }}
                                className={`fa fa-star ${review.ratings >= 3 && 'checked'}`}
                              ></span>
                              <span
                                style={{
                                  color: review.ratings >= 4 && reviewStarsColor,
                                }}
                                className={`fa fa-star ${review.ratings >= 4 && 'checked'}`}
                              ></span>
                              <span
                                style={{
                                  color: review.ratings == 5 && reviewStarsColor,
                                }}
                                className={`fa fa-star ${review.ratings == 5 && 'checked'}`}
                              ></span>
                            </div>
                            <div className='authour-name' style={cssSettingsND}>
                              <span className='title' style={cssSettingsND}>
                                {review.author}
                              </span>
                            </div>
                          </div>
                          {allowVote && (
                            <div className='review-helpful'>
                              <div className='review-helpful-txt'>
                                <span className='txt'>Was this Review Helpful ? </span>
                                <span className='review-yes'>
                                  <FontAwesomeIcon icon={['fas', 'thumbs-up']} style={{ color: reviewStarsColor }} />{' '}
                                  Yes{' '}
                                </span>
                                <span className='review-no'>
                                  <FontAwesomeIcon icon={['fas', 'thumbs-down']} style={{ color: reviewStarsColor }} />{' '}
                                  No
                                </span>
                              </div>
                              <div className='review-helpful-count'>
                                <span>{review.helpful_votes}</span> out of{' '}
                                <span>{review.helpful_votes + review.not_helpful_votes}</span> reviews are useful.
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )) ||
              (!preview && (
                <div className='reviewlist row'>
                  <div className='col-xl-6 col-lg-6 col-md-6'>
                    <div
                      className='review-sec empty-review-block'
                      style={{
                        color: reviewTextColor,
                        backgroundColor: reviewBgColor,
                      }}
                    >
                      <div className='review-author'>
                        <div className='authour-name'>
                          <span className='title'>
                            <Skeleton width={100} height={12} />
                          </span>
                          <Skeleton width={70} height={10} />
                        </div>
                        <div className='review-star'>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                        </div>
                      </div>
                      <div>
                        <span>
                          <Skeleton width={150} height={12} />
                        </span>
                        <p>
                          <Skeleton count={5} height={10} />
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='col-xl-6 col-lg-6 col-md-6'>
                    <div
                      className='review-sec empty-review-block'
                      style={{
                        color: reviewTextColor,
                        backgroundColor: reviewBgColor,
                      }}
                    >
                      <div className='review-author'>
                        <div className='authour-name'>
                          <span className='title'>
                            <Skeleton width={100} height={12} />
                          </span>
                          <Skeleton width={70} height={10} />
                        </div>
                        <div className='review-star'>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                          <span className={`fa fa-star`}></span>
                        </div>
                      </div>
                      <div>
                        <span>
                          <Skeleton width={150} height={12} />
                        </span>
                        <p>
                          <Skeleton count={5} height={10} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            {allowReview && (
              <div className='write-message'>
                <a href='#' className='btn btn-sm btn-success' style={buttonCss}>
                  Write a review
                </a>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

function _getDayMonth(date) {
  const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let fetchDate = new Date(date);
  const day = fetchDate.getDate();
  const month = monthName[fetchDate.getMonth()];
  return (
    <span className='authour-post-date'>
      {day < 10 ? '0' + day : day}
      <span>{month}</span>
    </span>
  );
}

function _formatDate(date) {
  let fetchDate = new Date(date);
  const day = fetchDate.getDate();
  const month = fetchDate.getMonth() + 1;
  const year = fetchDate.getFullYear();
  return (
    <span className='authour-post-date'>
      {(month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + '-' + year}
    </span>
  );
}
class ProductViewers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (!isEqual(this.props?.payload, nextProp?.payload) || !isEqual(this.props?.settings, nextProp?.settings)) {
      return true;
    }

    return false;
  }
  render() {
    const { dropzoneID, parentID, showBasicContent, showPreview, id, dropzoneProps, payload, datas, ...rest } =
      this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className='dragger'>
            {(Array.isArray(rest.icon) && <FontAwesomeIcon icon={rest.icon} />) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return (
        <div>
          <InitReviews preview={true} props={this.props} />
        </div>
      );
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        <InitReviews props={this.props} />
      </Draggable>
    );
  }
}

ProductViewers.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductViewers);
